/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-combo-container[_ngcontent-%COMP%] {\r\n    height: 100%;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n}\r\n\r\n.input-combo-title[_ngcontent-%COMP%] {\r\n    font-size: 14px;\r\n    padding-right: 10px;\r\n    padding-left: 10px;\r\n    min-width: 160px;\r\n}\r\n\r\n.input-combo-sub-container[_ngcontent-%COMP%] {\r\n    max-width: 240px;\r\n    width: 100%;\r\n}"];
export { styles as styles };
